import { render } from "./ManageReviewsPage.vue?vue&type=template&id=378cb929&ts=true"
import script from "./ManageReviewsPage.vue?vue&type=script&lang=ts"
export * from "./ManageReviewsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__